import React, { Component } from 'react';
import SDate from "./sdate.js";

export class Login extends Component {
    user = ""
    psw = ""
    state = { msg: null }

    async componentWillMount() {
        //debug
        if(localStorage.user) {
            const res = await window.fetchj("/login", { user: localStorage.user, psw: localStorage.psw });
            this.props.setLogin(res);
            return;
        }

        const res = await window.fetchj("/loginCheck")
        res.login && this.props.setLogin(res);
    }

    async login(e) {
        e.preventDefault();

        const res = await window.fetchj("/login", { user: this.user, psw: this.psw});
        if(!res.error) {
            this.props.setLogin(res);
        }
        else {
            this.setState({
                msg: res.errorMsg
            })
            console.warn("LOGIN failed!", res);


        }
    }

    render() {
        return (
        <>
        <div id="secure">
            <div id="secure-form">
                <div id="secure-form-logo">
                    <img src="/img/cathedral.jpg"/>
                    <img id="logo-portal" src="/img/portal3.svg"></img>
                </div>
                <form id="secure-form-inner">
                    <ul id="secure-form-tabs">
                        <li>Přihlášení</li>
                    </ul>
                    <div className="secure-form-fields" id="login-form">
                        <fieldset>
                            <label>Uživatelské jméno (email)</label>
                            <input type="text" id="username" onInput={e=> this.user = e.target.value}/>
                            {this.state.msg ? <label style={{color: "red"}}>{this.state.msg}</label> : []}
                        </fieldset>
                        <fieldset>
                            <label>Heslo</label>
                            <input type="password" id="password" onInput={e=> this.psw = e.target.value} />
                        </fieldset>
                        <button className="btn btn-primary" onClick={e => this.login(e)}>Přihlášení</button>
                    </div>
                </form>
                <div id="secure-form-footer">
                    &copy; {SDate.year} <a href="http://www.cathedral.cz" target="_blank" className="hrefCathedral">CATHEDRAL
                        Software, s.r.o. </a>
                </div>              
            </div>
        </div>

        <div id="company">
            <div id="company-logo">
            <a href="https://www.lamelland.sk" target="_blank"></a>
            </div>
            <div id="company-info">
                <img src="/img/uvodni.jpg" />
            </div>
            <div class="row">
            <div>
                <h2>Kontakt</h2> 
                <p>Netušilova 1622/3<br/>796 01 Prostějov</p>    
            </div>
            <div>        
                <h2>Telefon</h2>
                <p>SW: +420 588 207 283<br/>HW: +420 588 207 284</p>
            </div>
            <div>
                <h2>Email</h2><p><a href="mailto:podpora@cathedral.cz">podpora@cathedral.cz</a></p>
                <h2>Web</h2><p><a href="https://www.cathedral.cz" target="_blank">https://www.cathedral.cz</a></p>              
            </div>           
            </div>
        </div>
        </>
        );  
    }                  
}